import { eFontAsset, Game } from "../../../../Game";
import { Gameplay } from "../../../Gameplay";
import { Score as ScoreVal } from "../../../../Utils/Score";



export class Score {
    private _entity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(parent: pc.GraphNode, y: number) {
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            anchor: [0.5, 1, 0.5, 1],
            pivot: [0.5, 1],
            fontSize: 50,
            fontAsset: Game.app.assets.find(eFontAsset.arc8UI, pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
        });
        this._entity.setPosition(0, y, 0);
        parent.addChild(this._entity);

        // Zachytavat zmenu skore
        Gameplay.instance.events.on(ScoreVal.EVENT_SCORE_CHANGE, this.handleScoreChange, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._entity.element.text = "0";
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleScoreChange(score: ScoreVal, val: number): void {
        this._entity.element.text = val.toString();
    }
}